import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const KeyFacts = () => {

  return (
    <section className="py-md-5 pt-5 ">
      <div className="container">
       <div className="row">
        <div className="col-lg-6 text-center text-lg-start">
             <h2 className="mb-4 fs_32 fw-bold">GET AQUANTED WITH<br className="d-md-block d-none"/> OUR KEY FACTS</h2>
        </div>
        <div className="col-lg-6">
          <div className="row">
              <div className="col-sm-4 col-6 text-center">
                <h5 className="fs_48 mb-0 fw-bold">8.2<span className="textY">k</span></h5>
                <p className="text-gray mb-0 fs_17 fw-medium">Trusted Users</p>
            </div>
            <div className="col-sm-4 col-6 text-center">
                <h5 className="fs_48 mb-0 fw-bold">50<span className="textY">+</span></h5>
                <p className="text-gray mb-0 fs_17 fw-medium">Partners</p>
            </div>
            <div className="col-sm-4 col-6 mt-4 mt-sm-0 text-center">
                <h5 className="fs_48 mb-0 fw-bold">97<span className="textY">%</span></h5>
                <p className="text-gray mb-0 fs_17 fw-medium">Clients Satisfaction</p>
            </div>
          </div>
        </div>
       </div>

      </div>
    </section>
  );
};

export default KeyFacts;
